import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ObjetoSeguradoService } from "src/app/domain/services/parametros/objeto-segurado/objeto-segurado.service";
import { DialogComponent } from "../dialog/dialog.component";

@Component({
  selector: "app-insured-object-component",
  templateUrl: "./insured-object-component.component.html",
  styleUrls: ["./insured-object-component.component.scss"]
})
export class InsuredObjectComponentComponent implements OnInit, OnChanges {
  @Input() idTipoDeProposta: number;
  @Input() idProdutoCobertura: number;
  @Input() formGroup: UntypedFormGroup;
  @Input() objetoSeguradoSelecionado: any;
  @Input() textoObjetoSeguradoSelecionado: string;
  @Input() objetoSeguradoParametros: any;
  @Input() isDuplicated: boolean;
  @Input() step: number;

  @Output() changeText = new EventEmitter();

  constructor(
    private objetoSeguradoService: ObjetoSeguradoService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router
  ) { }

  //variables
  insuredText: string;
  listaObjetoSegurado = [];
  listaObjetoSeguradoAtualizada = [];
  isRead = this.activatedRoute.snapshot.routeConfig.path.includes("visualizar");
  isUpdate = this.activatedRoute.snapshot.routeConfig.path.includes("alterar");

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.idProdutoCobertura && changes.idProdutoCobertura.currentValue) {
      this.listaObjetoSegurado = [];
      this.listaObjetoSeguradoAtualizada = [];
      await this.carregarListaObjetoSegurado();
      if (this.objetoSeguradoParametros) {
        this.atualizarListaObjetoSegurado(this.objetoSeguradoParametros);
      }
    }
    if (changes.objetoSeguradoSelecionado && changes.objetoSeguradoSelecionado.currentValue) {
      if (this.isUpdate || this.isDuplicated) {
        if (!this.listaObjetoSegurado.find(o => o.id === this.objetoSeguradoSelecionado.id)) {
          this.listaObjetoSegurado.push({
            textoObjetoSegurado: this.objetoSeguradoSelecionado.text,
            id: this.objetoSeguradoSelecionado.id,
            oldText: true
          });
          this.atualizarListaObjetoSegurado(this.objetoSeguradoParametros);
        }
      }
    }
    if (changes.textoObjetoSeguradoSelecionado && changes.textoObjetoSeguradoSelecionado.currentValue) {
      if (this.isRead) {
        this.listaObjetoSeguradoAtualizada.push({
          textoObjetoSegurado: this.textoObjetoSeguradoSelecionado,
          id: this.objetoSeguradoSelecionado ? this.objetoSeguradoSelecionado.id : 1,
          oldText: false
        });
        this.selectObjetoSegurado({ value: this.objetoSeguradoSelecionado ? this.objetoSeguradoSelecionado.id : 1 });
      }
    }
    if (changes.objetoSeguradoParametros && changes.objetoSeguradoParametros.currentValue) {
      if (!this.isRead) {
        this.atualizarListaObjetoSegurado(changes.objetoSeguradoParametros.currentValue);
      }
    }
    if (changes.step && changes.step.currentValue) {
      if (this.step === 1) {
        if (this.isUpdate) {
          let index = this.listaObjetoSegurado.findIndex(o => o.oldText === true);
          if (index !== -1) {
            this.listaObjetoSegurado.splice(index, 1);
            this.insuredText = "";
            this.formGroup.controls.description.setValue("");
          }
          index = this.listaObjetoSeguradoAtualizada.findIndex(o => o.oldText === true);
          if (index !== -1) {
            this.listaObjetoSeguradoAtualizada.splice(index, 1);
            this.insuredText = "";
            this.formGroup.controls.description.reset();
          }
        }
      }
    }
  }

  ngOnInit(): void { }

  async carregarListaObjetoSegurado(): Promise<void> {
    await this.objetoSeguradoService
      .getObjetoSeguradoByIdProdutoCobertura(this.idProdutoCobertura)
      .toPromise()
      .then(res => {
        if (res.result !== null && res.result.filter(o => o.status === true).length) {
          this.listaObjetoSegurado = res.result;
          res.result.forEach(element => {
            this.listaObjetoSegurado.push(element);
          });
        } else {
          this.showModal(
            "Atenção",
            "Não existem parâmetros cadastrados para esta modalidade. Contate a Daycoval Seguros",
            null,
            "ENTENDI"
          );
        }
      });
  }

  showModal(title: string, text: string, firstNameButton: string, secondNameButton: string) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: { title, text },
      height: "238px",
      width: "480px"
    });
    dialogRef.componentInstance.firstNameButton = firstNameButton;
    dialogRef.componentInstance.secondNameButton = secondNameButton;
    dialogRef.componentInstance.eventSecondButton.subscribe(() => {
      this.router.navigate(["propostas/consultar"], { state: { bypassFormGuard: true } });
    });
  }

  atualizarListaObjetoSegurado(objetoSegurado): void {
    this.listaObjetoSegurado.forEach(object => {
      let text = object.textoObjetoSegurado;
      let isValid = true;
      if (text) {
        //substitui as tags do texto pelos campos caso eles estejam preenchidos
        Object.keys(objetoSegurado).forEach(parameter => {
          if (
            objetoSegurado[`${parameter}`] &&
            objetoSegurado[`${parameter}`].length &&
            !Array.isArray(objetoSegurado[`${parameter}`])
          ) {
            text = text.replace(`[${parameter}]`, this.formatText(objetoSegurado[`${parameter}`], parameter));
          } else if (Array.isArray(objetoSegurado[`${parameter}`])) {
            let textoMontado = "";
            objetoSegurado[`${parameter}`].forEach((element, index) => {
              if (index > 0) {
                textoMontado = textoMontado + `, ${this.formatText(element.nome, parameter)}`;
              } else {
                textoMontado = textoMontado + `, ${this.formatText(element.nome, parameter)}`;
              }
            });
            text = text.replace(`[${parameter}]`, textoMontado);
          }
        });
        //verifica se o texto ainda tem algum campo com tag
        Object.keys(objetoSegurado).forEach(parameter => {
          if (text.includes(`[${parameter}]`)) {
            isValid = false;
            if (this.listaObjetoSeguradoAtualizada.find(objeto => objeto.id === object.id)) {
              const index = this.listaObjetoSeguradoAtualizada.findIndex(o => o.id === object.id);
              if (index !== -1) {
                this.listaObjetoSeguradoAtualizada.splice(index, 1);
              }
            }
          }
        });
        //se o texto tiver algum campo com tag ele não é mostrado na lista
        if (isValid) {
          if (!this.listaObjetoSeguradoAtualizada.filter(objeto => objeto.id === object.id).length) {
            object.status
              ? this.listaObjetoSeguradoAtualizada.push({
                id: object.id,
                textoObjetoSegurado: text,
                oldText: object.oldText ? object.oldText : false
              })
              : "";
            // if(!this.isRead && !this.isUpdate){
            //   this.selectObjetoSegurado({text: text, value: object.id});
            // }
          } else {
            const index = this.listaObjetoSeguradoAtualizada.findIndex(o => o.id === object.id);
            if (index !== -1) {
              this.listaObjetoSeguradoAtualizada.splice(index, 1);
              object.status
                ? this.listaObjetoSeguradoAtualizada.push({
                  id: object.id,
                  textoObjetoSegurado: text,
                  oldText: object.oldText ? object.oldText : false
                })
                : "";
              // this.selectObjetoSegurado({value: object.id});
            }
          }
        }
      }
    });
    //caso a ação seja visualizar ou editar
    if (
      this.isRead ||
      this.isUpdate ||
      (this.isDuplicated &&
        this.formGroup.controls.description.value &&
        this.listaObjetoSeguradoAtualizada.filter(objeto => objeto.id === this.formGroup.controls.description.value)
          .length)
    ) {
      const payload = {
        value: this.formGroup.controls.description.value
      };
      this.selectObjetoSegurado(payload);
    }
  }

  selectObjetoSegurado(objetoSeguradoSelecionado): void {
    if (
      this.listaObjetoSeguradoAtualizada.length &&
      this.listaObjetoSeguradoAtualizada.find(o => o.id === objetoSeguradoSelecionado.value)
    ) {
      this.insuredText = this.listaObjetoSeguradoAtualizada.find(
        o => o.id === objetoSeguradoSelecionado.value
      ).textoObjetoSegurado;
      this.changeText.emit({
        text: this.listaObjetoSeguradoAtualizada.find(o => o.id === objetoSeguradoSelecionado.value)
          .textoObjetoSegurado,
        id: objetoSeguradoSelecionado.value
      });
    }
  }

  formatText(text, parameter): string {
    let formatedText = text;
    if (parameter.toLowerCase().includes("value") || parameter.toLowerCase().includes("valor")) {
      formatedText = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })
        .format(Number.parseInt(formatedText))
        .toString();
    }
    if (parameter.toLowerCase().includes("percentage") || parameter.toLowerCase().includes("porcentagem")) {
      formatedText = formatedText + "%";
    }
    if (parameter.toLowerCase().includes("cpf") || parameter.toLowerCase().includes("cnpj")) {
      const isCpf = formatedText.length === 11;
      if (isCpf) {
        formatedText = formatedText.replace(/[^\d]/g, "");

        formatedText = formatedText.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      } else {
        formatedText = formatedText.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
      }
    }
    if (parameter.toLowerCase().includes("numberprocess")) {
      formatedText = formatedText.replace(/[^\d]/g, "");

      formatedText = formatedText.replace(/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/g, "$1-$2.$3.$4.$5.$6");
    }
    return formatedText;
  }
}
